import * as v from 'valibot';

import {
  type Entities,
  type Filters,
  type FiltersUpdateApi,
  type Option,
  optionSchema,
  paginatedSchema,
} from './_core.model';

const optionalStringSchema = v.pipe(
  v.nullish(v.string()),
  v.transform((value) => value ?? ''),
);

export const carrierApiSchema = v.object({
  carrierAddr1: optionalStringSchema,
  carrierAddr2: optionalStringSchema,
  carrierCity: optionalStringSchema,
  carrierName: v.string(),
  carrierScacCode: optionalStringSchema,
  carrierShortName: optionalStringSchema,
  carrierState: optionalStringSchema,
  countryCode: optionalStringSchema,
  customerKey: v.optional(v.number()),
  id: v.number(),
  postalCode: optionalStringSchema,
  status: optionalStringSchema,
});

export const carrierSchema = v.object({
  ...carrierApiSchema.entries,
  ...optionSchema.entries,
  carrierAddr1: v.optional(v.string()),
  carrierAddr2: v.optional(v.string()),
  carrierCity: v.optional(v.string()),
  carrierScacCode: v.optional(v.string()),
  carrierShortName: v.optional(v.string()),
  carrierState: v.optional(v.string()),
  countryCode: v.optional(v.string()),
  id: v.string(),
  postalCode: v.optional(v.string()),
  status: v.optional(v.string()),
});

export const carriersApiSchema = paginatedSchema(carrierApiSchema);

export type CarrierApi = v.InferOutput<typeof carrierApiSchema>;
export type CarriersApi = v.InferOutput<typeof carriersApiSchema>;

export type CarrierFilters = Filters<CarrierApi>;

export type CarrierFiltersUpdateApi = FiltersUpdateApi<CarrierApi>;

export type Carrier = Prettify<Option<v.InferOutput<typeof carrierSchema>>>;

export type Carriers = Entities<Carrier> & { total: number };
